import WbSunnyIcon from '@mui/icons-material/WbSunny';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import OpacityIcon from '@mui/icons-material/Opacity';
import TuneIcon from '@mui/icons-material/Tune';
import SecurityIcon from '@mui/icons-material/Security';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import BuildIcon from '@mui/icons-material/Build';
import AdjustIcon from '@mui/icons-material/Adjust';

// Mesmo padrão de ICONE_POR_TIPO / ICONE_PADRAO usado em tiposAtividade.js.
// Lista de produto.nome levantada via grep em EditProposta.js (comparações
// de string tipo `proposta.produto?.nome === '...'`) — ainda não confirmada
// contra o cadastro oficial de Produto no banco.
//
// 'Proposta Comercial' e 'Gerador Grid-Zero' são tratados como apelidos
// legados de 'Gerador On-Grid' (ver EditProposta.js ~linha 900-908: o
// sistema grava 'On-Grid'/'Personalizado' aprovados como 'Proposta
// Comercial'), por isso compartilham o mesmo ícone.
//
// Ícones escolhidos do conjunto "clássico" do Material Icons (existem desde
// as versões antigas do @mui/icons-material) depois que WaterDrop deu
// "module not found" — o projeto parece estar numa versão do pacote sem os
// ícones mais recentes. Se quiser trocar por algo mais específico, é só
// mudar aqui, é o único lugar que precisa mudar.
export const ICONE_POR_PRODUTO = {
  'Gerador On-Grid': WbSunnyIcon,
  'Proposta Comercial': WbSunnyIcon,
  'Gerador Grid-Zero': WbSunnyIcon,
  'Gerador Off-Grid': BatteryChargingFullIcon,
  'Sistema de Bombeamento': OpacityIcon,
  Personalizado: TuneIcon,
  Seguro: SecurityIcon,
  Limpeza: LocalLaundryServiceIcon,
  Serviços: BuildIcon,
  'Proposta de Serviços': BuildIcon,
};

// Fallback para nome de produto fora do mapa acima (ou campo fechado sem
// seleção, se for esse o comportamento desejado no InputAdornment).
export const ICONE_PADRAO = AdjustIcon;